import {Types} from "../actions/payslipSampleActions";
import _ from "lodash";
import ReactPixel from 'react-facebook-pixel';

import cleanDeep from 'clean-deep';


const defaultState = {
  leave: {}
};

const payslipSampleReducers = (state = defaultState, action) => {
  switch (action.type) {
    
    case Types.PAYSLIP_SAMPLE_CREATING: {
      console.log('creating')
      let newState = {...state}
      newState.payslipSample = {
        creating: true,
        payslipDownloadLink: null,
      }
      
      window.gtag('event', 'generate_lead', {
        'event_category' : 'engagement',
        'event_label' : 'payslipSample'
      });

      ReactPixel.track('Lead',{
        content_name: "payslipSample",
      });

      return newState;
    }

    case Types.PAYSLIP_SAMPLE_READY: {
      let newState = {...state}
      newState.payslipSample = {
        creating: false,
        payslipDownloadLink: action.url,
      }

      return newState;
    }

    case Types.PAYSLIP_SAMPLE_CLEAR: {
      let newState = {...state}
      newState.payslipSample = {
        creating: false,
        payslipDownloadLink: null,
      }

      return newState;
    }

    default:
      return state;
  }
};

export default payslipSampleReducers;